/**
 * @generated SignedSource<<c58858bdd4df90461e4393bdf01dc8df>>
 * @relayHash d849399cc831644b331a67f2a0acb69f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44d72f44adeb9b1bbb0796d7ad33850e01fc0a82b74a6b268d8584be39c5c001

import type { ConcreteRequest } from 'relay-runtime';
export type MacrosByIdsQuery$variables = {
  cloudId: string;
  contentId: string;
  macroIds: ReadonlyArray<string>;
};
export type MacrosByIdsQuery$data = {
  readonly confluence_macrosByIds: ReadonlyArray<{
    readonly macroId: string;
    readonly renderedMacro: {
      readonly value: string | null;
      readonly webResource: {
        readonly contexts: ReadonlyArray<string | null>;
        readonly keys: ReadonlyArray<string | null>;
        readonly tags: {
          readonly css: string | null;
          readonly js: string | null;
        } | null;
      } | null;
    } | null;
  } | null> | null;
};
export type MacrosByIdsQuery = {
  response: MacrosByIdsQuery$data;
  variables: MacrosByIdsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "macroIds"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "macroIds",
        "variableName": "macroIds"
      }
    ],
    "concreteType": "Macro",
    "kind": "LinkedField",
    "name": "confluence_macrosByIds",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "macroId"
      },
      {
        "concreteType": "RenderedMacro",
        "kind": "LinkedField",
        "name": "renderedMacro",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          },
          {
            "concreteType": "WebResourceDependenciesV2",
            "kind": "LinkedField",
            "name": "webResource",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "keys"
              },
              {
                "kind": "ScalarField",
                "name": "contexts"
              },
              {
                "concreteType": "WebResourceTagsV2",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "js"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "css"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MacrosByIdsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MacrosByIdsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d849399cc831644b331a67f2a0acb69f",
    "id": "44d72f44adeb9b1bbb0796d7ad33850e01fc0a82b74a6b268d8584be39c5c001",
    "metadata": {},
    "name": "MacrosByIdsQuery",
    "operationKind": "query",
    "text": "query MacrosByIdsQuery($cloudId:ID!,$contentId:ID!,$macroIds:[ID!]!){confluence_macrosByIds(cloudId:$cloudId,contentId:$contentId,macroIds:$macroIds){macroId,renderedMacro{value,webResource{keys,contexts,tags{js,css}}}}}"
  }
};
})();

(node as any).hash = "d94684c822e8e102de57617f27a35478";

export default node;
